// Auto-generated from tokens.json — do not edit
// Import this in your App.tsx: import { tripsbyTokens } from './theme-tokens';

export const tripsbyTokens = {
  color: {
    brand: {
      green: {
          "50": "#F2F7F4",
          "100": "#DBECE2",
          "200": "#B8D9C5",
          "300": "#8CC2A2",
          "400": "#6BAF84",
          "500": "#548F65",
          "600": "#3C5945",
          "700": "#2E4635",
          "800": "#1F3025",
          "900": "#141F18"
    },
    },
    neutral: {
          "50": "#F7F7FA",
          "100": "#EDEFF5",
          "200": "#E3E5ED",
          "300": "#D1D4E0",
          "400": "#B1B2BA",
          "500": "#676970",
          "600": "#4B4C52",
          "700": "#303136",
          "800": "#18191C",
          "900": "#09090A",
          "white": "#FFFFFF",
          "black": "#181A20"
    },
    semantic: {
          "success": "#22C55E",
          "warning": "#F59E0B",
          "error": "#EF4444",
          "info": "#3B82F6"
    },
  },
  typography: {
    fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
  },
  radius: {
      "sm": "6px",
      "md": "8px",
      "lg": "12px",
      "xl": "16px",
      "2xl": "24px",
      "full": "9999px"
  },
  shadow: {
      "sm": "0 1px 2px rgba(53, 63, 98, 0.12)",
      "md": "0 2px 8px rgba(0, 0, 0, 0.08)",
      "lg": "0 4px 16px rgba(0, 0, 0, 0.12)",
      "xl": "0 8px 32px rgba(0, 0, 0, 0.16)"
  },
} as const;

/**
 * MUI theme partial — spread into createTheme()
 * Usage:
 *   import { muiThemePartial } from './theme-tokens';
 *   const theme = createTheme(muiThemePartial);
 */
export const muiThemePartial = {
  palette: {
    primary: {
      main: '#3C5945',
      light: '#548F65',
      dark: '#2E4635',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#B1B2BA',
      light: '#C5C6CD',
      dark: '#8E8F96',
    },
    background: {
      default: '#F7F7FA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#18191C',
      secondary: '#B1B2BA',
    },
    success: { main: '#22C55E' },
    warning: { main: '#F59E0B' },
    error: { main: '#EF4444' },
    info: { main: '#3B82F6' },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '2.5rem', fontWeight: 600 },
    h2: { fontSize: '2rem', fontWeight: 600 },
    h3: { fontSize: '1.5rem', fontWeight: 500 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none' as const, fontWeight: 500 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)' },
      },
    },
  },
};
